<template>
    <div class="w-100">
      <!--Button-->
      <div class="title" @click="goDetail">
        <!--title-->
        <div class="titlebox">
          <div class="cen-y">
            <div class="title">
              <b>{{document.title}}</b> {{document.type == 'image'?'첨부': '제출'}}
            </div>
            <div class="description">
              {{document.description}}
              <p v-if="document.title === '신분증사본'" class="warning-text">다른 사람의  신분증을 도용하거나 부정사용 시 처발 받을 수 있습니다.</p>
            </div>
          </div>
        </div>
        <!--Document-->
        <div class="checkbox" v-if="type == 'DOCUMENT'">
          <div class="checkbtn cen" :class="{'b-E3ECF6':isDocumentNotSubmitted, 'b-1BAAF1':isDocumentSubmitted}">
            <img class="cen" src="@/assets/images/documents/plus.svg" alt="arror-right" v-if="isDocumentNotSubmitted"/>
            <img class="cen" src="@/assets/images/documents/check.svg" alt="check" v-if="isDocumentSubmitted"/>
            <!--<i class="fas cen" :class="{'fa-plus':!document.file, 'fa-check':document.file}"></i>-->
          </div>
        </div>
        <!--Term-->
        <div class="checkbox" v-if="type == 'TERM'">
          <div class="checkbtn cen" :class="{'b-E3ECF6':!document.is_agreed, 'b-1BAAF1':document.is_agreed}">
            <img class="cen" src="@/assets/images/documents/arrow-right.svg" alt="arror-right" v-if="!document.is_agreed"/>
            <img class="cen" src="@/assets/images/documents/check.svg" alt="check" v-if="document.is_agreed"/>
            <!--<i class="fas cen" :class="{'fa-angle-right':!document.is_agreed, 'fa-check':document.is_agreed}"></i>-->
          </div>
        </div>
      </div>
      <!--Image-->
      <div class="image"
           v-if="document.file">
        <div v-if="document.title === '신분증사본'">
          <strong>신분증이 업로드 되었습니다</strong>
          <p class="description">* 개인정보 보호를 위해 신분증은 화면에 노출되지 않습니다</p>
        </div>
        <img class="w-100 h-auto xh-300px b-img bor-4px" :src="document.file" v-else/>
      </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'DocumentItem.vue',
  components: {},
  props: {
    document: {
      type: Object
    },
    type: {
      type: String
    }
  },
  data: function () { return {} },
  computed: {
    ...mapGetters('auth', {
      user: 'getProfile'
    }),
    isDocumentSubmitted() {
      let result = this.document.file
      if (this.document.title === '신분증사본') {
        result = !this.document.file && this.user.kyc.id_card_verification_is_done
      }
      return result
    },
    isDocumentNotSubmitted() {
      let result = !this.document.file
      if (this.document.title === '신분증사본') {
        result = !this.document.file && !this.user.kyc.id_card_verification_is_done
      }
      return result
    },
  },
  destroyed() {},
  methods: {
    goDetail() {
      if (!this.document.code) { return }
      let matches = this.document.code.match(/[a-zA-Z]+/g)
      let code = matches.join('').toLowerCase()
      this.$router.push({ name: 'documents/' + code })
    }
  }
}
</script>

<style lang="scss" scoped>
.title {
  width: 100%;
  height: 78px;

  .titlebox {
    width: calc(100% - 66px);
    height: 78px;
    padding-left: 20px;

    .title {
      width: 100%;
      height: auto;
      font-size: 18px;
      text-align: left;
      cursor: pointer;
    }

    .description {
      width: 100%;
      height: auto;
      margin-top: 6px;
      font-size: 14px;
      line-height: 16px;
      text-align: left;
      color: #727d8c;
    }
  }

  .checkbox {
    width: 66px;
    height: 100%;
  }

  .checkbtn {
    width: 26px;
    height: 26px;
    border-radius: 100%;
    color: white;
  }
}

.image {
  width: 100%;
  border-top-width: 1px;
  border-color: #D7E1EA;
  padding: 20px 32.5px;

  img {
    width: 100%;
    height: auto;
    max-height: 300px;
    border-radius: 4px;
  }

  .description {
    font-size: 14px;
  }
}

.warning-text {
  color: red;
  font-size: 12px;
}
</style>
